import * as React from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import DateHelper from 'app/helpers/dateHelper';
import { RatesDates } from 'app/pages/AgentPricing/models';
import { AgentCommissionStatus } from 'app/shared/model/AgentCommissionDto';
import './DiscountDatesEditor.css';

interface DiscountDatesEditorProps {
    dates: RatesDates;
    status: AgentCommissionStatus;
    changeStartDate: (date: string) => void;
    changeEndDate: (date: string | null) => void;
}

export function DiscountDatesEditor(props: DiscountDatesEditorProps) {
    const minDate = dayjs(props.dates.minChangeDate);
    const startDate = props.dates.startDate ? dayjs(props.dates.startDate) : null;
    const isExistingConfiguration = props.status !== AgentCommissionStatus.New;
    const today = dayjs().startOf('day');

    return (
        <div className="discount-dates-editor">
            <div className="discount-dates-editor__row">
                <div className="discount-dates-editor__field">
                    <label htmlFor="startDate" className="discount-dates-editor__label">
                        Effective from:
                    </label>
                    <DatePicker
                        id="startDate"
                        value={startDate ?? undefined}
                        onChange={date => props.changeStartDate(date ? date.format('YYYY-MM-DD') : '')}
                        format={DateHelper.DATE_PICKER_FORMATS}
                        className="discount-dates-editor__picker"
                        disabledDate={current => current && current.isBefore(minDate, 'day')}
                        allowClear={false}
                    />
                </div>
                <div className="discount-dates-editor__field">
                    <label htmlFor="endDate" className="discount-dates-editor__label">
                        Effective to:
                    </label>
                    <DatePicker
                        id="endDate"
                        value={props.dates.endDate ? dayjs(props.dates.endDate) : undefined}
                        onChange={date => props.changeEndDate(date ? date.format('YYYY-MM-DD') : null)}
                        format={DateHelper.DATE_PICKER_FORMATS}
                        className="discount-dates-editor__picker"
                        allowClear
                        disabledDate={current => {
                            if (!current) return false;
                            if (startDate && current.isBefore(startDate, 'day')) return true;
                            if (isExistingConfiguration && current.isBefore(today, 'day')) return true;
                            return false;
                        }}
                    />
                </div>
            </div>
            <div className="discount-dates-editor__helper">
                After this date, the office reverts to group rates.
            </div>
        </div>
    );
}